import { render, staticRenderFns } from "./DashPayments.vue?vue&type=template&id=57407dd0&scoped=true&"
import script from "./DashPayments.vue?vue&type=script&lang=js&"
export * from "./DashPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57407dd0",
  null
  
)

export default component.exports